/**
 * Eksekusi JTM Module
 * All URLs are passed from PHP via window.EksekusiJtmConfig to avoid hardcoding base_url().
 */
export function initEksekusiJtm() {
  const cfg = window.EksekusiJtmConfig || {};
  const findings = window.findingsData || [];

  // -------------------------------------------------------------------------
  // Geolocation Helper
  // -------------------------------------------------------------------------
  function detectGeolocation() {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        $('[name="latitude_eksekusi"]').val(pos.coords.latitude.toFixed(6));
        $('[name="longitude_eksekusi"]').val(pos.coords.longitude.toFixed(6));
      },
      (err) => console.warn('[Geo] Error:', err.message),
      { enableHighAccuracy: true, timeout: 5000 }
    );
  }

  // -------------------------------------------------------------------------
  // Material Recommendations Helper
  // -------------------------------------------------------------------------
  function loadMaterialRecommendations(idJenis) {
    const $container = $('#materialList');
    $container.html(
      '<div class="col-12 py-3 text-center"><div class="spinner-border spinner-border-sm text-primary" role="status"></div> <small class="text-muted ms-2">Memuat rekomendasi material...</small></div>'
    );
    $('#materialSection').removeClass('d-none');

    $.ajax({
      url: cfg.urlJenisPekerjaanMaterials,
      type: 'GET',
      data: { id_jenis: idJenis },
      success(res) {
        $container.empty();
        if (res.status === 'success' && res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            $container.append(`
                            <div class="col-12 border-bottom py-2">
                                <div class="row align-items-center">
                                    <div class="col-7">
                                        <div class="fw-semibold small">${item.nama_material}</div>
                                        <small class="text-muted">Standar: ${item.jumlah_standar} ${item.satuan}</small>
                                    </div>
                                    <div class="col-5">
                                        <div class="input-group input-group-sm">
                                            <input type="number" step="any" name="material[${item.id_material}]" class="form-control text-center" value="${item.jumlah_standar}" min="0">
                                            <span class="input-group-text">${item.satuan}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `);
          });
        } else {
          $container.html(
            '<div class="col-12"><small class="text-muted"><i class="bi bi-info-circle me-1"></i> Tidak ada material standar yang ditautkan untuk jenis tindakan ini.</small></div>'
          );
        }
      },
      error() {
        $container.html(
          '<div class="col-12 text-danger"><small>Gagal memuat rekomendasi material.</small></div>'
        );
      },
    });
  }

  // -------------------------------------------------------------------------
  // Tambah Eksekusi Button
  // -------------------------------------------------------------------------
  $('.btn-add-eksekusi').on('click', function () {
    $('#formEksekusi')[0].reset();
    $('#modalEksekusi .modal-title').html(
      '<i class="bi bi-clipboard-plus me-2"></i>Tambah Laporan Eksekusi'
    );
    $('#exec_id_inspeksi').val('').trigger('change');
    $('#piket_petugas').val([]).trigger('change');
    $('#exec_status').val('SELESAI').trigger('change');
    $('#materialSection').addClass('d-none');
    $('#materialList').html(
      '<div class="col-12"><small class="text-muted">Pilih Tindakan untuk melihat rekomendasi material...</small></div>'
    );
    detectGeolocation();
    $('#modalEksekusi').modal('show');
  });

  // -------------------------------------------------------------------------
  // Status Toggle (Kendala dropdown)
  // -------------------------------------------------------------------------
  $('#exec_status').on('change', function () {
    if ($(this).val() === 'KENDALA') {
      $('#exec_kendala_container').removeClass('d-none').slideDown();
      $('#exec_kendala').attr('required', true);
    } else {
      $('#exec_kendala_container').slideUp().addClass('d-none');
      $('#exec_kendala').removeAttr('required').val('').trigger('change');
    }
  });

  // -------------------------------------------------------------------------
  // Antrian Pekerjaan / Inspeksi Selection
  // -------------------------------------------------------------------------
  $('#exec_id_inspeksi').on('change', function () {
    const val = $(this).val();

    if (val === 'manual') {
      $('#manualEntryFields').removeClass('d-none').slideDown();
      $('#manualEntryFields select').attr('required', true);
      $('#materialSection').addClass('d-none');
      $('#materialList').html(
        '<div class="col-12"><small class="text-muted">Pilih Tindakan untuk melihat rekomendasi material...</small></div>'
      );
    } else if (val) {
      $('#manualEntryFields').slideUp().addClass('d-none');
      $('#manualEntryFields select').removeAttr('required');

      const finding = findings.find((f) => f.id_inspeksi === val);
      if (finding) {
        const lat = finding.latitude || finding.latitude_temuan;
        const lng = finding.longitude || finding.longitude_temuan;
        if (lat && lng) {
          $('[name="latitude_eksekusi"]').val(lat);
          $('[name="longitude_eksekusi"]').val(lng);
        }
        if (finding.id_jenis) {
          loadMaterialRecommendations(finding.id_jenis);
        } else {
          $('#materialSection').addClass('d-none');
        }
      }
    } else {
      $('#manualEntryFields').slideUp().addClass('d-none');
      $('#manualEntryFields select').removeAttr('required');
      $('#materialSection').addClass('d-none');
    }
  });

  // -------------------------------------------------------------------------
  // Cascading: Objek Pekerjaan → Jenis Pekerjaan (Tindakan)
  // -------------------------------------------------------------------------
  $('#id_objek_manual').on('change', function () {
    const idObjek = $(this).val();
    const $child = $('#id_jenis_manual');

    $child.empty().append('<option value="">-- Pilih Tindakan (Pilih Objek Dahulu) --</option>');
    if (!idObjek) return;

    $child.empty().append('<option value="">-- Memuat Tindakan... --</option>');
    $.ajax({
      url: cfg.urlJenisPekerjaanList,
      type: 'GET',
      data: { id_objek: idObjek },
      success(res) {
        $child.empty().append('<option value="">-- Pilih Tindakan --</option>');
        if (res.status === 'success' && res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            $child.append(`<option value="${item.id_jenis}">${item.nama_jenis}</option>`);
          });
        } else {
          $child.append('<option value="">-- Tidak ada tindakan yang tersedia --</option>');
        }
      },
      error() {
        $child.empty().append('<option value="">-- Gagal memuat tindakan --</option>');
      },
    });
  });

  // -------------------------------------------------------------------------
  // Cascading: Jenis Pekerjaan → Material Recommendations
  // -------------------------------------------------------------------------
  $('#id_jenis_manual').on('change', function () {
    const idJenis = $(this).val();
    if (idJenis) {
      loadMaterialRecommendations(idJenis);
    } else {
      $('#materialSection').addClass('d-none');
    }
  });

  // -------------------------------------------------------------------------
  // Detail View Modal
  // -------------------------------------------------------------------------
  $(document).on('click', '.btn-view-eksekusi', function () {
    const id = $(this).data('id');
    const $modal = $('#modalViewEksekusi');

    $modal.find('.loading').removeClass('d-none');
    $modal.find('.content-data').addClass('d-none');
    $modal.modal('show');

    $.ajax({
      url: cfg.urlEksekusiJson + '/' + id,
      type: 'GET',
      success(res) {
        if (res.status === 'success' && res.data) {
          const d = res.data;

          $modal.find('[data-view="kode_eksekusi_jtm"]').text(d.kode_eksekusi_jtm || '-');
          $modal
            .find('[data-view="nama_jenis"]')
            .text(d.nama_jenis || 'Input Manual / Tanpa Tindakan');
          $modal.find('[data-view="piket_petugas_names"]').text(d.piket_petugas_names || '-');
          $modal.find('[data-view="keterangan"]').text(d.keterangan || 'Tidak ada keterangan.');
          $modal.find('[data-view="nama_up3"]').text(d.nama_up3 || '-');
          $modal.find('[data-view="nama_ulp"]').text(d.nama_ulp || '-');
          $modal.find('[data-view="nama_penyulang"]').text(d.nama_penyulang || '-');
          $modal.find('[data-view="kode_tiang"]').text(d.kode_tiang || '-');

          const lat = d.latitude_eksekusi || '-';
          const lng = d.longitude_eksekusi || '-';
          if (lat !== '-' && lng !== '-') {
            $modal
              .find('[data-view="koordinat"]')
              .html(
                `<a href="https://maps.google.com/?q=${lat},${lng}" target="_blank" class="text-decoration-none"><i class="bi bi-geo-alt me-1"></i>${lat}, ${lng}</a>`
              );
          } else {
            $modal.find('[data-view="koordinat"]').text('-');
          }

          if (d.approved_name) {
            $('#view_approval_section').removeClass('d-none');
            $modal.find('[data-view="approved_name"]').text(d.approved_name);
            $modal.find('[data-view="approved_role"]').text(d.approved_role || '-');
            $modal.find('[data-view="approved_up3"]').text(d.approved_up3 || '-');
            $modal.find('[data-view="approved_ulp"]').text(d.approved_ulp || '-');

            let apprDateStr = '-';
            if (d.approved_at) {
              apprDateStr = new Date(d.approved_at).toLocaleString('id-ID', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              });
            }
            $modal.find('[data-view="approved_at"]').text(apprDateStr);
          } else {
            $('#view_approval_section').addClass('d-none');
          }

          // Format date
          let dateStr = '-';
          if (d.tanggal) {
            dateStr = new Date(d.tanggal).toLocaleDateString('id-ID', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            });
          }
          $modal.find('[data-view="tanggal"]').text(dateStr);

          // Status badge
          const statusMap = {
            SELESAI: '<span class="badge bg-success">SELESAI</span>',
            WAITING_APPROVAL: '<span class="badge bg-warning text-dark">WAITING APPROVAL</span>',
            REJECTED: '<span class="badge bg-danger">REJECTED</span>',
            DITUGASKAN: '<span class="badge bg-info text-dark">DITUGASKAN</span>',
          };
          let statusHtml = statusMap[d.status];
          if (!statusHtml) {
            if (d.status === 'KENDALA') {
              const note = d.kendala ? `: ${d.kendala}` : '';
              statusHtml = `<span class="badge bg-danger">KENDALA${note}</span>`;
            } else {
              statusHtml = `<span class="badge bg-secondary">${d.status || '-'}</span>`;
            }
          }
          $('#view_status_kendala').html(statusHtml);

          // Materials
          const $mat = $('#view_eksekusi_materials');
          $mat.empty();
          if (d.materials && d.materials.length > 0) {
            d.materials.forEach((m) => {
              $mat.append(
                `<tr><td>${m.nama_material}</td><td class="text-end fw-semibold" width="100">${m.jumlah_digunakan} ${m.satuan}</td></tr>`
              );
            });
          } else {
            $mat.html(
              '<tr><td colspan="2" class="text-center text-muted small py-3">Tidak ada material yang digunakan dalam laporan ini.</td></tr>'
            );
          }

          // Photos
          $('#view_img_temuan').attr(
            'src',
            d.foto_temuan ? cfg.urlInspeksiImage + '/' + d.foto_temuan : ''
          );
          $('#view_img_sebelum').attr(
            'src',
            d.foto_sebelum ? cfg.urlEksekusiImage + '/' + d.foto_sebelum : ''
          );
          $('#view_img_sesudah').attr(
            'src',
            d.foto_sesudah ? cfg.urlEksekusiImage + '/' + d.foto_sesudah : ''
          );
          $('#view_img_eviden').attr(
            'src',
            d.foto_eviden ? cfg.urlEksekusiImage + '/' + d.foto_eviden : ''
          );

          $modal.find('.loading').addClass('d-none');
          $modal.find('.content-data').removeClass('d-none');
        } else {
          $modal.modal('hide');
          Swal.fire('Gagal', 'Laporan eksekusi tidak dapat dimuat.', 'error');
        }
      },
      error() {
        $modal.modal('hide');
        Swal.fire('Error', 'Gagal menghubungi server.', 'error');
      },
    });
  });

  // -------------------------------------------------------------------------
  // Image Zoom Preview
  // -------------------------------------------------------------------------
  $(document).on('click', '.previewable-img', function () {
    const src = $(this).attr('src');
    if (!src) return;
    $('#fullPreviewImg').attr('src', src);
    $('#modalImgPreview').modal('show');
  });

  // -------------------------------------------------------------------------
  // Form Submit
  // -------------------------------------------------------------------------
  $('#formEksekusi').on('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $form = $(this);
    const formData = new FormData(this);

    Swal.fire({
      title: 'Kirim Laporan Eksekusi?',
      text: 'Pastikan foto BA dan koordinat lokasi sudah sesuai dengan kondisi riil.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ya, Kirim Laporan!',
      cancelButtonText: 'Batal',
      customClass: {
        confirmButton: 'btn btn-primary rounded-pill px-4 me-2',
        cancelButton: 'btn btn-light rounded-pill px-4',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (!result.isConfirmed) return;

      Swal.fire({
        title: 'Mengirim Laporan...',
        text: 'Mohon tunggu sebentar',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success(res) {
          if (res.status === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'Berhasil!',
              text: res.message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-primary rounded-pill px-4',
            }).then(() => {
              $('#modalEksekusi').modal('hide');
              location.reload();
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Gagal',
              text: res.message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-primary rounded-pill px-4',
            });
          }
        },
        error(xhr) {
          Swal.fire({
            icon: 'error',
            title: 'Terjadi Kesalahan',
            text: xhr.responseJSON?.message || 'Terjadi kesalahan sistem.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary rounded-pill px-4',
          });
        },
      });
    });
  });

  // -------------------------------------------------------------------------
  // Bulk Delete Logic
  // -------------------------------------------------------------------------
  const $btnBulk = $('#btnBulkDelete');
  const $selectedCount = $('#selectedCount');

  function updateBulkState() {
    const count = $('.check-item:checked').length;
    $selectedCount.text(count);
    $btnBulk.toggleClass('d-none', count === 0);
  }

  $(document).on('change', '#check-all, #checkAll', function () {
    $('.check-item').prop('checked', this.checked);
    updateBulkState();
  });

  $(document).on('change', '.check-item', function () {
    const total = $('.check-item').length;
    const checked = $('.check-item:checked').length;
    $('#check-all, #checkAll').prop('checked', total > 0 && total === checked);
    updateBulkState();
  });

  $btnBulk.on('click', function () {
    const ids = [];
    $('.check-item:checked').each(function () {
      ids.push($(this).val());
    });
    if (!ids.length) return;

    Swal.fire({
      title: 'Hapus data terpilih?',
      text: `Anda akan menghapus ${ids.length} laporan eksekusi terpilih.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, Hapus!',
      cancelButtonText: 'Batal',
      customClass: {
        confirmButton: 'btn btn-danger rounded-pill px-4 me-2',
        cancelButton: 'btn btn-light rounded-pill px-4',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (!result.isConfirmed) return;

      Swal.fire({
        title: 'Memproses...',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      $.ajax({
        url: cfg.urlBulkDelete,
        type: 'POST',
        data: { [cfg.csrfToken]: cfg.csrfHash, ids },
        success(res) {
          if (res.status === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'Berhasil!',
              text: res.message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-primary rounded-pill px-4',
            }).then(() => location.reload());
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Gagal',
              text: res.message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-primary rounded-pill px-4',
            });
          }
        },
        error(xhr) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: xhr.responseJSON?.message || 'Gagal menghapus data.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary rounded-pill px-4',
          });
        },
      });
    });
  });

  // -------------------------------------------------------------------------
  // Single Delete
  // -------------------------------------------------------------------------
  $(document).on('click', '.btn-delete-submit', function (e) {
    e.preventDefault();
    const $form = $(this).closest('form');

    Swal.fire({
      title: 'Hapus Laporan Eksekusi?',
      text: 'Laporan eksekusi ini akan dihapus dan status inspeksi dikembalikan ke TEMUAN.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, Hapus!',
      cancelButtonText: 'Batal',
      customClass: {
        confirmButton: 'btn btn-danger rounded-pill px-4 me-2',
        cancelButton: 'btn btn-light rounded-pill px-4',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (!result.isConfirmed) return;

      Swal.fire({
        title: 'Memproses...',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: $form.serialize(),
        success(res) {
          if (res.status === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'Berhasil!',
              text: res.message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-primary rounded-pill px-4',
            }).then(() => location.reload());
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Gagal',
              text: res.message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-primary rounded-pill px-4',
            });
          }
        },
        error(xhr) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: xhr.responseJSON?.message || 'Gagal menghapus data.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary rounded-pill px-4',
          });
        },
      });
    });
  });

  // -------------------------------------------------------------------------
  // Cascading Filter (UP3 → ULP → Penyulang) – Filter Bar
  // -------------------------------------------------------------------------
  $('#id_up3_filter').on('change', function () {
    const up3s = $(this).val() || [];
    const $ulp = $('#id_ulp_filter');
    const $peny = $('#id_penyulang_filter');
    $ulp.empty().trigger('change');
    $peny.empty().trigger('change');
    if (!up3s.length) return;

    $.ajax({
      url: cfg.urlUlpList,
      type: 'GET',
      data: { id_up3: up3s },
      success(res) {
        if (res.status === 'success' && res.data) {
          res.data.forEach((i) => $ulp.append(new Option(i.nama_ulp, i.id_ulp, false, false)));
          $ulp.trigger('change');
        }
      },
    });
  });

  $('#id_ulp_filter').on('change', function () {
    const ulps = $(this).val() || [];
    const $peny = $('#id_penyulang_filter');
    $peny.empty().trigger('change');
    if (!ulps.length) return;

    $.ajax({
      url: cfg.urlPenyulangList,
      type: 'GET',
      data: { id_ulp: ulps },
      success(res) {
        if (res.status === 'success' && res.data) {
          res.data.forEach((i) =>
            $peny.append(new Option(i.nama_penyulang, i.id_penyulang, false, false))
          );
          $peny.trigger('change');
        }
      },
    });
  });

  // -------------------------------------------------------------------------
  // Cascading Modal Form (UP3 → ULP → Penyulang → Tiang)
  // -------------------------------------------------------------------------
  $('[name="id_up3"]').on('change', function () {
    const id = $(this).val();
    const $ulp = $('[name="id_ulp"]');
    const $peny = $('[name="id_penyulang"]');
    const $tiang = $('[name="id_tiang"]');
    $ulp.empty().append('<option value="">-- Pilih ULP --</option>').trigger('change');
    $peny.empty().append('<option value="">-- Pilih Penyulang --</option>').trigger('change');
    $tiang.empty().append('<option value="">-- Lokasi Tiang --</option>').trigger('change');
    if (!id) return;

    $.ajax({
      url: cfg.urlUlpList,
      type: 'GET',
      data: { id_up3: [id] },
      success(res) {
        if (res.status === 'success' && res.data) {
          res.data.forEach((i) => $ulp.append(new Option(i.nama_ulp, i.id_ulp, false, false)));
        }
      },
    });
  });

  $('[name="id_ulp"]').on('change', function () {
    const id = $(this).val();
    const $peny = $('[name="id_penyulang"]');
    const $tiang = $('[name="id_tiang"]');
    $peny.empty().append('<option value="">-- Pilih Penyulang --</option>').trigger('change');
    $tiang.empty().append('<option value="">-- Lokasi Tiang --</option>').trigger('change');
    if (!id) return;

    $.ajax({
      url: cfg.urlPenyulangList,
      type: 'GET',
      data: { id_ulp: [id] },
      success(res) {
        if (res.status === 'success' && res.data) {
          res.data.forEach((i) =>
            $peny.append(new Option(i.nama_penyulang, i.id_penyulang, false, false))
          );
        }
      },
    });
  });

  $('[name="id_penyulang"]').on('change', function () {
    const id = $(this).val();
    const $tiang = $('[name="id_tiang"]');
    $tiang.empty().append('<option value="">-- Lokasi Tiang --</option>').trigger('change');
    if (!id) return;

    $.ajax({
      url: cfg.urlTiangList,
      type: 'GET',
      data: { id_penyulang: id },
      success(res) {
        if (res.status === 'success' && res.data) {
          res.data.forEach((i) =>
            $tiang.append(new Option(i.kode_tiang, i.id_tiang, false, false))
          );
        }
      },
    });
  });
}
